import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { notificationRtkApi } from '@/features/notifications/services/notificationRtkApi';
import actingOnBehalfReducer from './actingOnBehalfSlice';
import permissionsReducer from './permissionsSlice';
import privacyReducer from './privacySlice';
import userReducer from './userSlice';

// Combine all reducers
export const rootReducer = combineReducers({
  user: userReducer,
  permissions: permissionsReducer,
  actingOnBehalf: actingOnBehalfReducer,
  privacy: privacyReducer,
  [notificationRtkApi.reducerPath]: notificationRtkApi.reducer,
});

// Configure redux-persist. ``privacy`` is intentionally NOT whitelisted:
// the toggles are session-only shoulder-surf protections and reset on
// refresh by design.
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'actingOnBehalf'],
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(notificationRtkApi.middleware),
});

// Create persistor
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
